import { useQuery } from "@tanstack/react-query";
import { millisecondsInMinute } from "date-fns";

import { api } from "@contexts";
import type { Template } from "@interfaces";

export const useTemplate = (templateId: string) => {
  return useQuery({
    queryKey: ["template", templateId],
    queryFn: () =>
      api<Template>({
        url: `/templates/${templateId}`,
      }),
    enabled: !!templateId,
    staleTime: 5 * millisecondsInMinute,
  });
};
